import { gmiRequest } from 'actions/request';
import { actions } from '@ehi/global-marketing-interface';

export const modifyReservationStart =
  ({ redirect = true } = {}) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.reservations.modifyStart(),
        loadingOverlay: true,
        redirect,
      })
    );
